import { render } from "./CallLog.vue?vue&type=template&id=4d67d4ec&scoped=true"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"

import "./CallLog.vue?vue&type=style&index=0&id=4d67d4ec&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d67d4ec"]])

export default __exports__